"use client"

import { getCustomerRefferal, getUserCredentialApi } from "@/services/Redux/Reducer/CustomerSlice";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { _logoutFunction, storeAssigned, _ProductStructure, _getPrice } from "@/services/Methods/normalMethods";
import _ from "lodash";
import useIpDetection from "./useIpDetection";
import { LoginApi } from "@/services/Redux/Reducer/LoginSlice";
import { getAllProductApiPagination } from "@/services/Redux/Reducer/AllProductSlice";
import { Email, Password } from "@mui/icons-material";
const STORES = ["ae", "at", "be", "bg", "br", "by", "cl", "co", "cr", "cy", "cz", "de", "dk", "ec", "ee", "es", "fi", "fr", "gr", "hr", "hu", "ie", "il", "it", "jo", "kh", "kz", "la", "lk", "lt", "lu", "lv", "mk", "mt", "mx", "my", "nl", "no", "pa", "pe", "ph", "pl", "ps", "pt", "ro", "ru", "se", "si", "sk", "th", "ua", "us"];

const useRefferalHook = (props, section) => {

    const { pathname, router, isUserLogin, params, searchParams } = props;

    const dispatch = useDispatch();
    const [pageNotFound, setPageNotFound] = useState(false);
    const [urlRefferal, setUrlRefferal] = useState(null);
    const [isReferralLoading, setLoading] = useState(true);
    const [refferalCheckPopup, setRefferalCheckPopup] = useState(false);
    const { success } = useIpDetection(STORES, params?.store, router, pathname);

    useEffect(() => {
        const redirectTo = searchParams.get("redirectTo");
        if (redirectTo && isUserLogin) {

            // _logoutFunction("notRedirect"); -- comment the code for testing the purpose of autoship rule we uncomment once the ssokey was enable


            // router.push(`/${storeAssigned()}/main-enrollment`);
            router.push(`/${storeAssigned()}/${redirectTo}`);
        }
    }, [])


    useEffect(() => {
        // if (section === 'urlRefferalCheck') {
        //     _checkRefferalCode(params?.store, section);

        //     // && _.includes(STORES, params?.store)
        // }
        if (pathname && !searchParams.get('ssokey') && _.includes(STORES, params?.store)) {
            setTimeout(() => setLoading(false), 2000);
        }
    }, [pathname]);
    useEffect(() => {
        if (section === 'urlRefferalCheck') {
            console.log("params?.store", params?.store)
            _checkRefferalCode(params?.store, section);
            if (searchParams.get('productCart')) {
                success();
            }
            // && _.includes(STORES, params?.store)
        }
    }, []);

    // console.log(localStorageCall().getItem("refferal_link"), 'dddddddddddddddddddddddddddddddd');

    function _handleYesClick(action = "no", refferalData) {
        if (action === 'yes') {
            localStorageCall().setItem("refferal_link", JSON.stringify(refferalData));
        }
        if (searchParams.get('partyPlanId')) {
            localStorageCall().setItem('partyPlanId', searchParams.get('partyPlanId'))
        }
        if (searchParams?.get('pid') && searchParams?.get('placement') && searchParams?.get('tree')) {
            if (isUserLogin) {
                _logoutFunction('notRedirect');
            }
            const TreeMoveData = {
                pid: searchParams.get('pid'),
                placementId: searchParams.get('placement'),
                treeType: searchParams.get('tree'),
                placementType: searchParams.get('placementType')
            }
            localStorageCall().setItem('TreeMoveData', JSON.stringify(TreeMoveData));
            // const URL = (searchParams.get('role') === 'customer') ? 'distributor' : 'distributor'
            const URL = (searchParams.get('role') === 'customer') ? 'main-enrollment' : ''
            window?.location.assign(`/${storeAssigned()}/${URL}`);
        } else {
            const REDIRECT_PAGE = searchParams.get('redirectTo') ? searchParams.get('redirectTo') : "";
            if (REDIRECT_PAGE) {
                router.push(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}` : `/${storeAssigned()}`);
            } else {
                router.push(`/${storeAssigned()}`)
            }
        }
    }

    function _checkRefferalCode(refferal, section = "refferalPopup", errorCallback) {
        if (!(STORES?.includes(params?.store))) {

            const REDIRECTS_PAGE = searchParams.get('redirectTo') ? searchParams.get('redirectTo') : "";


            console.log("newone***********", searchParams.get('action'), searchParams.get('username'), searchParams.get('password'))
            if (searchParams.get('action') === 'smartsave') {
                sessionStorage.setItem('action', 'smartsave');

                // dispatch(LoginApi(value, (data) => {
                //     if (data) {
                //         if (searchParams.get('redirectTo')) {
                //             router.push(searchParams.get('redirectTo'));
                //         } else {
                //             router.push('/');
                //         }
                //     }
                // }));

                window.location.assign(REDIRECTS_PAGE ? `/${storeAssigned()}${REDIRECTS_PAGE}` : `/${storeAssigned()}`);
            }


            if (searchParams.get('ssokey')) {
                if (searchParams.get('partyPlanId')) {
                    localStorageCall().setItem('partyPlanId', searchParams.get('partyPlanId'))
                }

                const REDIRECT_PAGE = searchParams.get('redirectTo') ? searchParams.get('redirectTo') : "";


                console.log("newone", searchParams.get('action'))
                if (searchParams.get('action') === 'smartsave') {
                    sessionStorage.setItem('action', 'smartsave');

                    window.location.assign(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}` : `/${storeAssigned()}`);
                }

                console.log("REDIRECT_PAGEREDIRECT_PAGEREDIRECT_PAGE", REDIRECT_PAGE, "searchParams.get('action')", searchParams.get('action'));

                // if (searchParams.get('action')) {
                //     sessionStorage.setItem('action', 'smartsave');

                //     window.location.assign(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}` : `/${storeAssigned()}`);

                // }

                dispatch(getUserCredentialApi(searchParams.get('ssokey'), router, REDIRECT_PAGE));
            } else {
                dispatch(getCustomerRefferal((data) => {
                    if (data?.length === 0) {
                        // setPageNotFound(true);
                        router.push(`/${storeAssigned()}`)
                    } else {
                        const PRODUCT_CART = searchParams.get('productCart') ? searchParams.get('productCart') : "";
                        const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
                        if (PRODUCT_CART) {
                            const refferalData = { "id": data[0]?.customerId, "name": data[0]?.fullName || data[0]?.publicProfile?.fullName, "webalies": data[0]?.webAlias, userDetail: data?.[0], "type": data[0]?.customerTypeDescr };
                            localStorageCall().setItem("refferal_link", JSON.stringify(refferalData));
                            const SPLIT_MULTI_PRODUCT = _.split(PRODUCT_CART, ',');
                            console.log("SPLIT_MULTI_PRODUCT", SPLIT_MULTI_PRODUCT);
                            dispatch(getAllProductApiPagination(0, 1000, (data) => {
                                const RESULTS = _.map(data, (row) => {
                                    let CONDITION = _.includes(['prospect'], CUSTOMER_TYPE?.role) ? _getPrice(row, 4) : _.includes(['company'], CUSTOMER_TYPE?.role) ? _getPrice(row, 3) : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 5) : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 4) : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 3) : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || _.includes(pathname, 'distributor')) ? _getPrice(row, 2) : _getPrice(row, 1);
                                    if (CONDITION || (CONDITION === 0)) {
                                        if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === storeAssigned())) {
                                            const data = _ProductStructure(row)
                                            return data;
                                        }
                                    }
                                });
                                console.log("RESULTS", RESULTS);
                                const ADD_PRODUCTS = _.map(SPLIT_MULTI_PRODUCT, (el) => {
                                    const SPLIT_DATA = _.split(el, ':');
                                    console.log("SPLIT_DATA", SPLIT_DATA);
                                    const originalCode = SPLIT_DATA[0];
                                    const baseCode = originalCode.slice(0, -2);
                                    const newCountryCode = storeAssigned().toUpperCase();
                                    const transformedCode = `${baseCode}${newCountryCode}`;

                                    const MATCHED_PRODUCTS = _.find(RESULTS, { itemCode: SPLIT_DATA[0] });
                                    console.log("MATCHED_PRODUCTS", MATCHED_PRODUCTS);
                                    return MATCHED_PRODUCTS ? { ...MATCHED_PRODUCTS, frequency: SPLIT_DATA[2] === '2' ? 'autoship' : 'oneTime', quantity: +SPLIT_DATA[1], onlySubscription: SPLIT_DATA[3] === 'true' } : null;
                                })
                                console.log(ADD_PRODUCTS, "ADD_PRODUCTS");
                                if (_.compact(ADD_PRODUCTS).length > 0) {
                                    localStorageCall().setItem('normalProducts', JSON.stringify(_.compact(ADD_PRODUCTS)))
                                    router.push(`/${storeAssigned()}/checkout`);
                                } else {
                                    router.push(`/${storeAssigned()}`)
                                }
                            }))


                        } else {
                            try {
                                const refferalData = { "id": data[0]?.customerId, "name": data[0]?.fullName || data[0]?.publicProfile?.fullName, "webalies": data[0]?.webAlias, userDetail: data?.[0], "type": data[0]?.customerTypeDescr };
                                localStorageCall().setItem("refferal_link", JSON.stringify(refferalData));
                                // setUrlRefferal(refferalData);
                                // setRefferalCheckPopup(true);
                                if (searchParams?.get('pid') && searchParams?.get('placement') && searchParams?.get('tree')) {
                                    if (isUserLogin) {
                                        _logoutFunction('notRedirect');
                                    }
                                    const TreeMoveData = {
                                        pid: searchParams.get('pid'),
                                        placementId: searchParams.get('placement'),
                                        treeType: searchParams.get('tree'),
                                        placementType: searchParams.get('placementType')
                                    }
                                    localStorageCall().setItem('TreeMoveData', JSON.stringify(TreeMoveData));
                                    const URL = (searchParams.get('role') === 'customer') ? 'main-enrollment' : ''
                                    window?.location.assign(`/${storeAssigned()}/${URL}`);
                                } else {
                                    if (isUserLogin) {
                                        _logoutFunction('notRedirect');
                                    }
                                    const REDIRECT_PAGE = searchParams.get('redirectTo') ? searchParams.get('redirectTo') : "";
                                    if (REDIRECT_PAGE) {
                                        window.location.assign(REDIRECT_PAGE ? `/${storeAssigned()}${REDIRECT_PAGE}` : `/${storeAssigned()}`);
                                    } else {
                                        window.location.assign(`/${storeAssigned()}`)
                                    }
                                }

                            } catch (err) {
                                console.log(err)
                            }
                        }
                    }
                }, refferal, 'urlRef'));
            }
        }
    }




    return ({
        pageNotFound, urlRefferal, setUrlRefferal, refferalCheckPopup, setRefferalCheckPopup,
        _checkRefferalCode,
        _handleYesClick,
        isReferralLoading
    })
};

export default useRefferalHook;